import moment, { Moment } from 'moment-timezone'
import _map from 'lodash/map'
import _max from 'lodash/max'
import _min from 'lodash/min'
import Duration from 'utils/duration'
import { Card } from 'antd'
import { Line } from 'react-chartjs-2'
import { TApiProject } from 'services/api-client/types'
import getDaysBetweenDatesArray from '../utils/get-days-between-dates-array'

const CumulativeTimeChart = ({ projectInsights, project }: { projectInsights: any, project: TApiProject }): JSX.Element => {

  // @ts-ignore
  // console.errobr('insights -> ', projectInsights.toJSON())

  const timeData = projectInsights.timeData

  const entriesArray = Object.keys(timeData).map((time) => {
    return {
      key: time,
      date: moment(time),
      ...timeData[time as any],
    }
  })
  const entriesDates = _map(entriesArray, (dateEntry) => dateEntry.date )

  const firstDate = _min(entriesDates) as Moment
  const lastDate = _max(entriesDates) as Moment

  let xUnit = 'month' // day by default
  const daysDiff = lastDate.diff(firstDate, 'd')

  if (daysDiff <= 60) xUnit = 'day' // display days on xAxe if time span is smaller than 60 days
  if (daysDiff >= 1095) xUnit = 'year' // display years on xAxe if time span is bigger than 3 years

  const datesRange = getDaysBetweenDatesArray(firstDate, lastDate)

  const labels = _map(datesRange, (date) => {
    return date
  })

  let chartValue = 0
  const dataEntries = _map(datesRange, (date: any) => {
    const entryValue = timeData[date.format("YYYYMMDD")]

    if (entryValue?.duration) {
      chartValue = chartValue + entryValue.duration
    } 

    return chartValue
  })

  const datasets = []
  const projectBudgetTime = (project.budgetTime as number) * 60 // TODO: get budget in minutes?

  datasets.unshift({
      label: '',
      borderColor: '#6060CB',
      fill: false,
      data: dataEntries,
      pointRadius: 0,
  })

  if (project.budgetType == 'time') {
    datasets.unshift({
      fill: false,
      borderColor: '#ccc',
      data: _map(datesRange, (date: any) => { return projectBudgetTime}),
      pointRadius: 0,
    })
  }

  const data = {
    labels: labels,
    datasets: datasets,
  }

  const legend = {
    display: false,
  }

  const options = {
    tooltips: {
      callbacks: {
        label: (tooltipItem: any) => {

          if (tooltipItem.datasetIndex == 0) {
            // @ts-ignore
            return `Project budget: ${new Duration(projectBudgetTime).toHoursString()}`
          }

          const value = dataEntries[tooltipItem.index]
          // @ts-ignore
          return new Duration(value).toDurationString()
        },

        title: function(tooltipItem: any, data: any) {
          const date = datesRange[tooltipItem[0].index]
          return date.format("DD.MM.YYYY")
        }
      }
    },
    scales: {
      yAxes: [{
        ticks: {
          stepSize: 600,
          callback: (value: any) => {
            return new Duration(value).toHoursString()
          },
        }
      }],

      xAxes: [{
        type: 'time',
        time: {
          unit: xUnit,
        }
      }]
    }
  }  

  return (
    <Card style={{ height: '380px' }}>
      <h3>Cumulative Time Logged </h3>
      <Line 
        legend={legend}
        height={70} 
        data={data} 
        options={options}
        type="line" 
      />
    </Card>
  )
}


export default CumulativeTimeChart